<template>

  <div class="licence-uploader">

    <h2>{{ $t('title.add-licence') }}</h2>

    <data-form :entity="server" :fields="fields" @submit="submit" :cancel="false" />

  </div>

</template>

<script>
import { post } from 'providers/http'

export default {
  name: 'licence-uploader',
  props: {
    'server': {
      type: Object,
      required: true
    }
  },
  computed: {
    fields () {
      return {
        'license': {
          type: 'textarea',
          rules: [{ required: true }]
        }
      }
    }
  },
  methods: {
    async submit ({id, license}) {
      try {
        await post('api/v1/servers/add-license', {id, license})
      }
      catch (err) {
        console.error(err)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// LicenceUploader.vue?47ec7b14